import Store from './store'

export interface Data {
  id: number
}

export type EndpointType = 'fetch' | 'save' | 'delete' | 'create'

class Model<T extends Data, S = any> extends Store<S> {
  readonly data: T

  constructor(parent: S, data: T) {
    super(parent)
    this.data = data
  }

  get id() {
    return this.data.id
  }

  get searchText() {
    return ''
  }
}

export default Model
